import React from 'react';
import { useTranslation } from 'react-i18next';
import { Modal } from 'semantic-ui-react';
import TermsAndConditionsDetails from '../TermsAndConditionsDetails';
import { TriggerCSS, ContentCSS } from './styles';


const TermsAndConditionsModal = () => {
  const { t } = useTranslation('general');
  return (
    <Modal trigger={
      (
        <TriggerCSS>
          {t('termsAndConditions')}
        </TriggerCSS>
      )
    }
    >
      <Modal.Header>
        {t('termsAndConditions')}
      </Modal.Header>
      <Modal.Content>
        <ContentCSS>
          <TermsAndConditionsDetails />
        </ContentCSS>
      </Modal.Content>
    </Modal>
  )
}

export default TermsAndConditionsModal;